<template>
  <v-footer app class="mavFooter">
    <v-snackbar color="cyan" v-model="refreshPage" bottom :timeout="timeout">
      <v-icon color="white" style="padding-right: 10px">mdi-information-outline</v-icon>
      {{ refreshPageTxt }}
      <v-btn color="purple" text @click="doRefreshPage()"> Refresh </v-btn>
    </v-snackbar>
    <div class="hidden-sm-and-down">
      Copyright © {{ new Date().getFullYear() }} Premium Systems Technology Pte Ltd.&nbsp;&nbsp;Co Reg No. 198103071K.&nbsp;&nbsp;All Rights
      Reserved.&nbsp;&nbsp; <!-- |<a :href="privUrl" target="_blank" class="pl-2" color="primary">Privacy & Security</a> -->
    </div>
    <div class="hidden-md-and-up">Copyright © {{ new Date().getFullYear() }} {{ projectShort }}. Reg No. {{ coyReg }}. All Rights Reserved.</div>
    <v-spacer></v-spacer>
    <div class="hidden-sm-and-down">Powered by Maverick ({{ appVersion }})</div>
  </v-footer>
</template>

<script>
import { AppInfoMixin } from '@/mixins/global/appInfo'

export default {
  data: () => ({
    refreshPage: false,
    timeout: 30000,
    refreshPageTxt: 'A new Odyssey5 version is available.'
  }),
  mounted() {
    this.initVersionCheck()
  },
  methods: {
    // AR 13-Jun-2020: Refresh page to reset cache -- Start
    initVersionCheck() {
      if (this.$store.state.token.token && this.$store.state.token.token !== '') {
        // const apiURL = this.$store.state.app.baseMenu.getAppVersion
        // if (apiURL) {
        setTimeout(() => {
          const apiURL = process.env.BASE_URL + 'appInfo/globalProps.json?t=' + new Date().getTime()
          // console.log(apiURL)
          this.getAppVersion(apiURL)
        }, this.intervalCheck)
        // }
      }
    },
    doRefreshPage() {
      this.refreshPage = false
      window.location.reload(true)
    },
    async getAppVersion(apiURL) {
      this.$http
        .get(apiURL)
        .then((result) => {
          // let appVersionNew = result.data.resultMap.appVersion
          let appVersionNew = result.data.appInfo.appVersion
          if (appVersionNew !== this.appVersion && this.refreshPage === false && this.intervalCheck !== null) {
            window.localStorage.setItem('appVersion', appVersionNew)
            this.refreshPage = true
          }
        })
        .catch((err) => {})
    }
    // AR 13-Jun-2020: Refresh page to reset cache -- End
  },
  computed: {
    projectTitle() {
      return this.$store.state.app.projectTitleLong
    },
    projectShort() {
      return this.$store.state.app.projectTitle
    },
    coyReg() {
      return process.env.VUE_APP_COYREG
    },
    privUrl() {
      if (process.env.VUE_APP_PRIVURL) {
        return process.env.VUE_APP_PRIVURL
      } else {
        return '/'
      }
    },
    BUSSTRUC() {
      return process.env.VUE_APP_BUSSTRUC
    },
    appVersion() {
      if (window.localStorage.getItem('appVersion')) {
        return window.localStorage.getItem('appVersion')
      } else {
        if (this.appInfo.appVersion) {
          return this.appInfo.appVersion
        } else {
          return 'O5_DEV_20010101'
        }
      }
    },
    intervalCheck() {
      if (this.appInfo.intervalCheck) {
        return this.appInfo.intervalCheck
      } else {
        return 30000
      }
    }
  },
  mixins: [AppInfoMixin]
}
</script>

<style lang="scss">
.mavFooter {
  padding-left: 5px;
  padding-right: 5px;
  font-size: 0.9em;
}
</style>
